"use client";

import { cn } from "@oreme/ui";
import {
  Binoculars,
  LandPlot,
  ChartLine,
  Tag,
  Image as Picture,
  Telescope,
} from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { ObjectTypeEnum } from "@/types";

interface ObjectIconProps extends HTMLAttributes<HTMLSpanElement> {
  object: ObjectTypeEnum;
  size?: number;
}

function ObjectIcon({
  object,
  size = 20,
  className,
  ...props
}: Readonly<ObjectIconProps>): ReactElement {
  const t = useTranslations("global.Object");
  let icon, label;

  switch (object) {
    case ObjectTypeEnum.OBSERVATION:
      icon = <Binoculars strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.OBSERVATION);
      break;
    case ObjectTypeEnum.DEVICE:
      icon = <Telescope strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.DEVICE);
      break;
    case ObjectTypeEnum.SITE:
      icon = <LandPlot strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.SITE);
      break;
    case ObjectTypeEnum.TIMESERIE:
      icon = <ChartLine strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.TIMESERIE);
      break;
    case ObjectTypeEnum.THEME:
      icon = <Tag strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.THEME);
      break;
    case ObjectTypeEnum.TAG:
      icon = <Tag strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.TAG);
      break;
    case ObjectTypeEnum.PICTURE:
      icon = <Picture strokeWidth={1} size={size} />;
      label = t(ObjectTypeEnum.PICTURE);
      break;
  }

  return (
    <span
      className={cn("inline-flex gap-1.5 items-center", className)}
      {...props}
    >
      {icon}
      <span className="text-xs uppercase">{label}</span>
    </span>
  );
}

export { ObjectIcon, type ObjectIconProps };
